import Record from 'services/api/record.ts'

export interface ButtonTypeMapping {
	color: string
	icon: string
	text: string
	dataTest: string
}

export const typeMapping: Record<string, ButtonTypeMapping> = {
	return: {
		color: 'info',
		icon: 'common.return.icon',
		text: 'common.return.name',
	},
	releaseNote: {
		color: 'primary',
		icon: 'common.releaseNote.icon',
		text: 'common.releaseNote.name',
		dataTest: 'link-btn',
	},
	add: {
		color: 'info',
		icon: 'common.add.icon',
		text: 'common.add.name',
		dataTest: 'add-btn',
	},
	save: {
		color: 'success',
		icon: 'common.save.icon',
		text: 'common.save.name',
		dataTest: 'save-btn',
	},
	cancel: {
		color: 'error',
		icon: 'common.cancel.icon',
		text: 'common.cancel.name',
		dataTest: 'cancel-btn',
	},
	close: {
		color: 'info',
		icon: 'common.close.icon',
		text: 'common.close.name',
		dataTest: 'close-btn',
	},
	delete: {
		color: 'error',
		icon: 'common.delete.icon',
		text: 'common.delete.name',
		dataTest: 'delete-btn',
	},
	update: {
		color: 'warning',
		icon: 'common.update.icon',
		text: 'common.update.name',
		dataTest: 'update-btn',
	},
	reload: {
		color: 'info',
		icon: 'common.reload.icon',
		text: 'common.reload.name',
		dataTest: 'reload-btn',
	},
	setting: {
		color: 'info',
		icon: 'common.settings.icon',
		text: 'common.settings.name',
		dataTest: 'setting-btn',
	},
}

export default typeMapping
